<script lang="ts" setup>
import IconLogo from '@@/packages/shared/components/logo/IconLogo.vue';
import { useThemePreference } from '@@/packages/shared/composables/theme';

defineProps<{
  // Optional caption shown under the logo (pass an already-translated string).
  message?: string;
}>();

const { theme } = useThemePreference();
</script>

<template>
  <div
    class="flex h-full w-full flex-col items-center justify-center gap-6x"
    :class="{ 'tw-dark bg-black': theme === 'classic' }"
  >
    <IconLogo color="primary" loading class="h-[48px] w-auto" />
    <p v-if="message" class="text-md text-neutral-muted">{{ message }}</p>
  </div>
</template>
